const linkStyles = (theme) => ({
  root: {
    color: theme.palette.red.red60,
    fontWeight: 'bold',
  },
});

export default linkStyles;
